<template>
    <div>
        <router-view />
    </div>
</template>

<script>
    export default {
        name: "UserWrapper"
    }
</script>

<style scoped>

</style>